import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../shared/AuthContext';
import { usePermissions } from '../shared/permissions';

/**
 * Route wrapper that requires the user to be staff or superuser.
 * Redirects to /dashboard if the user is authenticated but not an admin.
 * Redirects to /login if not authenticated at all.
 */
function AdminRoute({ children }) {
  const { isAuthenticated, loading } = useAuth();
  const { isAdmin } = usePermissions();
  const location = useLocation();

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading…</span>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }

  if (!isAdmin) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
}

export default AdminRoute;
